<template>
  <div>
    <apexchart
      ref="barchart"
      :options="chartOptions"
      :series="series"
      type="bar"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      series: [
        {
          data: []
        }
      ],
      chartOptions: {
        chart: {
          height: "100%",
          type: "bar"
        },
        colors: ["#E31E52", "#fccd00", "#03AC0E", "#EE4D2D", "#1890FF"],
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: true,
          formatter: function(seriesName, opts) {
            return `${seriesName} ${[
              opts.w.globals.series[0][opts.seriesIndex]
            ]}`;
          },
          fontSize: "12px"
        },
        xaxis: {
          categories: ["Raw", "In Progress", "Need Review", "Reopen", "Closed"],
          labels: {
            style: {
              fontSize: "12px"
            }
          }
        },
        noData: {
          text: "Tidak ada data yang tersedia"
        },
        title: {
          text: "Total Scrape Semua Status",
          style: {
            fontFamily: "CircularStd",
            fontSize: "20px",
            fontWeight: 500
          }
        },
        tooltip: {
          followCursor: true,
          x: {
            show: false
          },
          y: {
            formatter: function(
              value,
              { series, seriesIndex, dataPointIndex, w }
            ) {
              return value;
            },
            title: {
              formatter: (seriesName, series) => {
                return `${series.w.globals.labels[series.dataPointIndex]}`;
              }
            }
          }
        }
      }
    };
  },
  async created() {
    await this.loadItems();
  },
  methods: {
    async loadItems() {
      await this.$store
        .dispatch("agent/getTotalScrapeStatus")
        .then(response => {
          let series = [];
          let labels = [];
          const { data } = response;
          data.forEach(element => {
            series.push(element.total);
            labels.push(element.status);
          });
          this.updateChart(series, labels);
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateChart(series, labels) {
      series.every(item => item < 1) ? (series = []) : series;
      this.$refs.barchart.appendData([{ data: series }]);
    }
  }
};
</script>

<style>
.apexcharts-legend.apexcharts-align-center.apx-legend-position-bottom {
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/totalScrapeStatusAgent.vue